import bdReq from '../../network/bdReq';
import bdAuth from '../../network/bdAuth';

import {
  FETCH_ACTIVE_PLAYLIST_REQUEST,
  FETCH_ACTIVE_PLAYLIST_SUCCESS,
  FETCH_ACTIVE_PLAYLIST_FAILURE,
  FETCH_FEATURED_PLAYLIST_REQUEST,
  FETCH_FEATURED_PLAYLIST_SUCCESS,
  FETCH_FEATURED_PLAYLIST_FAILURE,
  FETCH_PORTRAIT_FEATURED_PLAYLIST_REQUEST,
  FETCH_PORTRAIT_FEATURED_PLAYLIST_SUCCESS,
  FETCH_PORTRAIT_FEATURED_PLAYLIST_FAILURE,
  FETCH_USER_PLAYLISTS_REQUEST,
  FETCH_USER_PLAYLISTS_SUCCESS,
  FETCH_USER_PLAYLISTS_FAILURE,
  CLEAR_FEATURED_PLAYLIST,
  CLEAR_USER_PLAYLISTS,
  CLEAR_ACTIVE_PLAYLIST,
  FETCH_HOME_PLAYLIST_REQUEST,
  FETCH_HOME_PLAYLIST_SUCCESS,
  FETCH_HOME_PLAYLIST_FAILURE,
  FETCH_MY_PLAYLIST_REQUEST,
  FETCH_MY_PLAYLIST_SUCCESS,
  FETCH_MY_PLAYLIST_FAILURE,
} from '../constants/playlistConstants';

export const clearFeaturedPlaylist = () => ({ type: CLEAR_FEATURED_PLAYLIST });
export const clearUserPlaylists = () => ({ type: CLEAR_USER_PLAYLISTS });
export const clearActivePlaylist = () => ({ type: CLEAR_ACTIVE_PLAYLIST });

const fetchFeaturedPlaylistRequest = () => ({ type: FETCH_FEATURED_PLAYLIST_REQUEST });
const fetchFeaturedPlaylistSuccess = (payload) => ({ type: FETCH_FEATURED_PLAYLIST_SUCCESS, payload });
const fetchFeaturedPlaylistFailure = (errors) => ({ type: FETCH_FEATURED_PLAYLIST_FAILURE, errors });

const fetchPortraitFeaturedPlaylistRequest = () => ({ type: FETCH_PORTRAIT_FEATURED_PLAYLIST_REQUEST });
const fetchPortraitFeaturedPlaylistSuccess = (payload) => ({ type: FETCH_PORTRAIT_FEATURED_PLAYLIST_SUCCESS, payload });
const fetchPortraitFeaturedPlaylistFailure = (errors) => ({ type: FETCH_PORTRAIT_FEATURED_PLAYLIST_FAILURE, errors });

export const fetchFeaturedPlaylist = () => async (dispatch) => {
  dispatch(fetchFeaturedPlaylistRequest());
  try {
    const tokens = bdAuth.getToken();
    const id = tokens ? tokens.user : 'anonymous';
    // const url = `/users/${id}/playlists/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx`;
    const url = '/v2/collections/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx';
    const response = await bdReq.get(url);
    if (response.success) {
      return dispatch(fetchFeaturedPlaylistSuccess(response.body));
    }
    return dispatch(fetchFeaturedPlaylistFailure('Could not fetch featured playlist.'));
  } catch (e) {
    return dispatch(fetchFeaturedPlaylistFailure(e));
  }
};

export const fetchPortraitFeaturedPlaylist = () => async (dispatch) => {
  dispatch(fetchPortraitFeaturedPlaylistRequest());
  try {
    const tokens = bdAuth.getToken();
    const id = tokens ? tokens.user : 'anonymous';
    const url = '/v2/collections/b1f908bb-9722-4e70-ac5c-653ad45ee3ea';
    const response = await bdReq.get(url);
    if (response.success) {
      return dispatch(fetchPortraitFeaturedPlaylistSuccess(response.body));
    }
    return dispatch(fetchPortraitFeaturedPlaylistFailure('Could not fetch featured playlist.'));
  } catch (e) {
    return dispatch(fetchPortraitFeaturedPlaylistFailure(e));
  }
};

const fetchUserPlaylistsRequest = () => ({ type: FETCH_USER_PLAYLISTS_REQUEST });
const fetchUserPlaylistsSuccess = (payload) => ({ type: FETCH_USER_PLAYLISTS_SUCCESS, payload });
const fetchUserPlaylistsFailure = (errors) => ({ type: FETCH_USER_PLAYLISTS_FAILURE, errors });

export const fetchUserPlaylists = () => async (dispatch) => {
  dispatch(fetchUserPlaylistsRequest());
  try {
    const tokens = bdAuth.getToken();
    // const url = `/users/${tokens.user.id}/home`;
    const url = '/v2/collections';
    const response = await bdReq.get(url);
    if (response.success) {
      const playlists = response.body.collections;
      // .filter((l) => l.type === 'playlist-list' && l.heading === 'Collections')
      // .map((item) => item.content)
      // .flat();
      return dispatch(fetchUserPlaylistsSuccess(playlists));
    }
    return dispatch(fetchUserPlaylistsFailure('Could not fetch user playlists.'));
  } catch (e) {
    return dispatch(fetchUserPlaylistsFailure(e));
  }
};

const fetchActivePlaylistRequest = () => ({ type: FETCH_ACTIVE_PLAYLIST_REQUEST });
export const fetchActivePlaylistSuccess = (payload) => ({ type: FETCH_ACTIVE_PLAYLIST_SUCCESS, payload });
const fetchActivePlaylistFailure = (errors) => ({ type: FETCH_ACTIVE_PLAYLIST_FAILURE, errors });

export const fetchActivePlaylist = (playlistId) => async (dispatch) => {
  dispatch(fetchActivePlaylistRequest());
  try {
    const user = bdAuth.getToken();
    // const url = `/users/${user.user}/playlists/${playlistId}`;
    const url = `/v2/collections/${playlistId}`;
    const response = await bdReq.get(url);
    if (response.status === 200 && response.body.collection.artwork.length <= 0) {
      return dispatch(fetchActivePlaylistFailure('No Artworks'));
    } if (response.status === 200 && response.success) {
      return dispatch(fetchActivePlaylistSuccess(response.body.collection));
    } if (response.status === 404) {
      return dispatch(fetchActivePlaylistFailure('Error'));
    }
    return dispatch(fetchActivePlaylistFailure('Could not fetch playlist.'));
  } catch (e) {
    return dispatch(fetchActivePlaylistFailure(e));
  }
};

const fetchHomePlaylistRequest = () => ({ type: FETCH_HOME_PLAYLIST_REQUEST });
const fetchHomePlaylistSuccess = (payload) => ({ type: FETCH_HOME_PLAYLIST_SUCCESS, payload });
const fetchHomePlaylistFailure = (errors) => ({ type: FETCH_HOME_PLAYLIST_FAILURE, errors });

export const fetchHomePlaylist = () => async (dispatch) => {
  dispatch(fetchHomePlaylistRequest());
  try {
    //  const url = '/collections';
    const url = '/v2/categories';
    const response = await bdReq.get(url);
    if (response.status === 404) {
      return dispatch(fetchHomePlaylistFailure('Error'));
    }

    const res = response.body.categories;
    const items = [];
    const x = res.forEach((category) => {
      category.collections.forEach((itm) => {
        // const file = itm.Files[0];

        items.push({
          playlistId: itm.id,
          ...itm,
        });
      });
    });

    // / let res = response.body.filter(item => item.media !== undefined);
    // const items = res.map((itm) => {
    // const file = itm.Files[0];

    // return {
    //  playlistId: itm.id,
    //  img: itm.media,
    // ...file
    // }
    // });

    return dispatch(fetchHomePlaylistSuccess(items));
  } catch (e) {
    return dispatch(fetchHomePlaylistFailure(e));
  }
};

const fetchMyPlaylistRequest = () => ({ type: FETCH_MY_PLAYLIST_REQUEST });
const fetchMyPlaylistSuccess = (payload) => ({ type: FETCH_MY_PLAYLIST_SUCCESS, payload });
const fetchMyPlaylistFailure = (errors) => ({ type: FETCH_MY_PLAYLIST_FAILURE, errors });

export const fetchMyPlaylist = () => async (dispatch) => {
  dispatch(fetchMyPlaylistRequest());
  try {
    const user = bdAuth.getToken();
    // const url = `/users/${user.user}/playlists`;
    const url = '/v2/collections';
    const response = await bdReq.get(url);
    if (response.status === 404) {
      return dispatch(fetchMyPlaylistFailure('Error'));
    }

    const items = response.body.collections.reduce((itm, option) =>
      // if (option.artwork.length > 0) {
      itm.concat({
        playlistId: option.id,
        ...option,
      }),
    // }
    // return itm;
    []);

    // let res = response.body.filter(item => item.media !== undefined);
    // const items = res.map((itm) => {
    //   const file = itm;
    //   return {
    //     playlistId: itm.id,
    //     ...file
    //   }
    // });

    return dispatch(fetchMyPlaylistSuccess(items));
  } catch (e) {
    return dispatch(fetchMyPlaylistFailure(e));
  }
};
